import { render, staticRenderFns } from "./DataReportOrdenes.vue?vue&type=template&id=ecd164a2"
import script from "./DataReportOrdenes.vue?vue&type=script&lang=js"
export * from "./DataReportOrdenes.vue?vue&type=script&lang=js"
import style0 from "./DataReportOrdenes.vue?vue&type=style&index=0&id=ecd164a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports